import type { CalendarFormState, CalendarScope, EventType } from "./types";

export const API_PATH = "/school-calendar-events";
export const ICAL_PATH = "/calendar/school.ics";
export const OFFICIAL_SCHOOL_HOLIDAYS_BASE_URL =
  "https://opendata.rijksoverheid.nl/v1/infotypes/schoolholidays";
export const SCHOOL_YEAR_STORAGE_KEY = "lumen.schoolCalendar.schoolYearUuid";

export const SCOPES: CalendarScope[] = ["SCHOOL", "CLASSROOM"];
export const EVENT_TYPES: EventType[] = [
  "HOLIDAY",
  "STUDY_DAY",
  "DAY_OFF",
  "SCHOOL_EVENT",
  "CLASS_ACTIVITY",
  "FIELD_TRIP",
  "SPORTS_DAY",
  "PARENT_INFORMATION",
  "PARENT_EVENING",
  "OTHER",
];

export const emptyForm: CalendarFormState = {
  scope: "SCHOOL",
  classroomUuids: [],
  schoolYearUuid: "",
  title: "",
  description: "",
  eventType: "OTHER",
  startDate: "",
  startTime: "",
  endDate: "",
  endTime: "",
  allDay: false,
  location: "",
  published: false,
};
